// import { store } from '@/store/store'
import { temAcesso } from '@/bibliotecas/seguranca/authLib'

const PerfisAcesso = () => import('./PerfisAcesso')
const PerfisAcessoForm = () => import('./PerfisAcessoForm')
const PerfilRegrasAcesso = () => import('./PerfilRegrasAcesso')

export default {
  path: 'perfisacesso',
  name: 'PerfisAcesso',
  component: PerfisAcesso,
  beforeEnter: (to, from, next) => {
    if (temAcesso('CTRLACS-PA-00')) {
      next()
    }
  },
  children: [
    {
      path: 'inserir',
      name: 'PerfisAcesso_Inserir',
      component: PerfisAcessoForm,
      beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-PA-01')) {
          next()
        }
      }
    },
    {
      path: 'detalhar/:perfilAcessoId',
      name: 'PerfisAcesso_Detalhar',
      component: PerfisAcessoForm,
      beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-PA-02')) {
          next()
        }
      }
    },
    {
      path: 'atualizar/:perfilAcessoId',
      name: 'PerfisAcesso_Atualizar',
      component: PerfisAcessoForm,
      beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-PA-03')) {
          next()
        }
      }
    },
    {
      path: 'regrasacesso/:perfilAcessoId',
      name: 'PerfisAcesso_RegrasAcesso',
      component: PerfilRegrasAcesso,
      beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-PA-05')) {
          next()
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/modulos/admin/controleacesso/perfisacesso/PerfilAcessoRotas.js